import { render, staticRenderFns } from "./PickupRequestForm.vue?vue&type=template&id=228034d8&scoped=true"
import script from "./PickupRequestForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PickupRequestForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228034d8",
  null
  
)

export default component.exports